import React from "react"

import LayoutHeaderMenu from "../LayoutHeaderMenu/LayoutHeaderMenu"

import ShowMoreWrapper from "./ShowMore"

import { Link } from "gatsby"
import ConditionalWrapper from "../ConditionalWrapper/ConditionalWrapper"

import "./productModules.scss"
import "../Industries/industries.scss"

import { makeStyles } from "@material-ui/core/styles"

import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
import DeviceCarousel from "../DeviceCarousel/DeviceCarousel"

import SearchIcon from "@material-ui/icons/Search"
import CloseIcon from "@material-ui/icons/Close"

import useMediaQuery from "@material-ui/core/useMediaQuery"
import { navigate } from "gatsby"

const ProductModules = (props) => {
  const uri = props.uri.split("/")

  const [open, setOpen] = React.useState(false)

  const fullScreen = useMediaQuery("(max-width: 1023px)")

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    navigate(`/product/virtualconsultant`)
  }

  const useStyles = makeStyles({
    dialog: {
      backgroundColor: "transparent",
      margin: 0,
      padding: "10px 0px !important",
      maxWidth: "lg",
      "@media screen and (max-width: 767px)": {
        padding: "0",
        width: "100%",
        margin: "0",
      },
    },
    dialogWrapper: {
      width: "1000px",
      height: "700px",
      margin: "auto auto",
      "@media screen and (max-width: 1023px)": {
        width: "700px",
      },
      "@media screen and (max-width: 767px)": {
        width: "100%",
        height: "100%",
      },
    },
    title: {
      textAlign: "center",
      fontFamily: "Bariol Regular",
      "@media screen and (max-width: 767px)": {
        fontSize: "12pt",
      },
    },
    close: {
      display: "none",
      "@media screen and (max-width: 1023px)": {
        display: "flex",
        position: "absolute",
        top: "20px",
        right: "20px",
        cursor: "pointer",
      },
    },
  })

  const classes = useStyles()

  const {
    set_metadata,
    text_header_title,
    text_header_description,
    asset_header_picture,
    text_title,
    asset_logo,
    wysiwyg_short_description,
    text_video_tag,
    wysiwyg_description,
    wysiwyg_description_2,
    arr_module_cards,
    arr_gallery_images,
  } = props.pageContext.content.product_modules

  const siteMetadata = {
    title: set_metadata.text_page_title,
    description: set_metadata.text_page_description,
    meta: [
      {
        name: "keywords",
        content: set_metadata.text_keywords,
      },
    ],
    author: `prodHost`,
  }

  return (
    <div className="product_modules-wrapper">
      <LayoutHeaderMenu
        siteMetadata={siteMetadata}
        header_logo={
          props.pageContext.content.global_values.set_logos
            .asset_prodhost_logo_white_120p
        }
        header_title={text_header_title}
        header_description={text_header_description}
        header_background={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${asset_header_picture.path}`}
        header_shaded
        menu={props.pageContext.menu.entries}
        selected={`${uri[1]}`}
        selected2={`${uri[1]}_${uri[2]}`}
        expanded
        footer={props.pageContext.content.global_values.set_footer}
      >
        <div className="head-wrapper">
          <div className="layout-industries-head">
            <div className="image-wrapper">
              <img
                src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${asset_logo.path}`}
                alt="product_modules_logo"
              />
            </div>
            <div className="layout-industries-title">
              <h1>{text_title}</h1>
              <div
                className="description"
                dangerouslySetInnerHTML={{ __html: wysiwyg_short_description }}
              ></div>
            </div>
          </div>
          {props.pageContext.content.apiVideoData.data.map((video, index) => {
            if (
              video.description &&
              video.description.includes(text_video_tag)
            ) {
              return (
                <div
                  key={index}
                  className="video-wrapper"
                  dangerouslySetInnerHTML={{ __html: video.assets.iframe }}
                ></div>
              )
            }
          })}
          <div className="desktop">
            {wysiwyg_description ? (
              <div
                dangerouslySetInnerHTML={{ __html: wysiwyg_description }}
              ></div>
            ) : null}
            {wysiwyg_description_2 ? (
              <div
                dangerouslySetInnerHTML={{ __html: wysiwyg_description_2 }}
              ></div>
            ) : null}
          </div>

          <div className="mobile">
            <ShowMoreWrapper
              item_1={wysiwyg_description}
              item_2={wysiwyg_description_2}
            />
          </div>
          {arr_gallery_images ? (
            <div
              className="gallery_thumbnail"
              onKeyDown={() => {
                handleClickOpen()
              }}
              onClick={() => {
                handleClickOpen()
              }}
              style={{ marginBottom: "30px" }}
            >
              <div className="arrowup-icon">
                <SearchIcon />
              </div>
              <img
                src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${arr_gallery_images[0].value.path}`}
                alt="virtual_consultant"
              />
            </div>
          ) : null}
          {arr_gallery_images ? (
            <Dialog
              className={`device-dialog ${classes.dialogWrapper}`}
              fullScreen={fullScreen}
              open={open}
              onClose={() => handleClose()}
              aria-labelledby="form-dialog-title"
            >
              <DialogContent className={classes.dialog}>
                <h1 className={classes.title}>Galéria</h1>
                <div className={classes.close} onClick={() => handleClose()}>
                  <CloseIcon />
                </div>
                <DeviceCarousel carousel={arr_gallery_images} />
              </DialogContent>
            </Dialog>
          ) : null}
        </div>
        <div className="body-wrapper">
          {arr_module_cards.map((card, index) => {
            return (
              <ConditionalWrapper
                condition={card.value.text_module_url}
                wrapper={(children) => (
                  <Link
                    to={card.value.text_module_url}
                    className="item-card-wrapper"
                    key={index}
                  >
                    {children}
                  </Link>
                )}
                key={index}
              >
                <div className="item-card-without-wrapper">
                  <div className="icon-wrapper">
                    <img
                      className="icon"
                      src={`${process.env.GATSBY_CMS_URL_STORAGE_UPLOADS_2}${card.value.asset_module_picture.path}`}
                      alt="product_module_icon"
                    />
                  </div>
                  <div className="description-wrapper">
                    <h2>{card.value.text_module_title}</h2>
                    <div
                      className="description"
                      dangerouslySetInnerHTML={{
                        __html: card.value.wysiwyg_module_description,
                      }}
                    ></div>
                  </div>
                </div>
              </ConditionalWrapper>
            )
          })}
        </div>
      </LayoutHeaderMenu>
    </div>
  )
}

export default ProductModules
